import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, matchPath } from 'react-router-dom';
import find from 'lodash/find';
import { injectIntl } from 'react-intl';
import NotificationSystem from 'react-notification-system';

import * as ErrorActions from '../../state/handler/ErrorActions';
import * as LayoutActions from '../../state/layout/LayoutActions';
import * as SessionActions from '../../state/session/SessionActions';
import * as LocaleActions from '../../state/locale/LocaleActions';
import * as RouteActions from '../../state/route/RouteActions';
import * as NotificationActions from '../../state/notification/NotificationActions';
import * as ScrollbarActions from '../../state/scrollbar/scrollbarActions';
import * as AccountActions from '../../state/account/AccountActions';
import * as DataActions from '../../state/data/DataActions';
import * as MessageActions from '../../state/message/MessageActions';
import * as DashboardActions from '../../state/dashboard/DashboardActions';
import * as DisclosureActions from '../../state/disclosure/DisclosureActions';
import * as CompanyActions from '../../state/company/CompanyActions';
import * as UploadActions from '../../state/upload/UploadActions';
import createRoutes, { flattenRoutes } from '../../configs/routes';
import { getLayoutRoute } from '../../state/route/routeSelector';
import { MAIN_LAYOUT } from '../../configs/AppConfig';
import NotificationStyle from '../../assets/styles/NotificationStyle';

import AppTitle from '../common/Title/AppTitle';
import ErrorBoundary from './ErrorBoundary';
import { makeStyles } from '@material-ui/styles';
import { getCompanyDomain } from '../../state/company/companySelector';

export const ActionContext = React.createContext(null);
export const SessionContext = React.createContext(null);
export const LayoutContext = React.createContext(null);
export const RouterContext = React.createContext(null);
export const LocaleContext = React.createContext(null);

const MainContainerStyle = makeStyles(theme => (
  {
    root: {
      // position: 'fixed',
      // width: '100vw',
      // height: '100vh',
      // overflowY: 'auto',
      // overflowX: 'hidden',
      backgroundColor: '#f0f1f2'
    }
  }
));

const MainContainer = props => {
  const {
    actions,
    session,
    locale,
    layout,
    match,
    location,
    history,
    LayoutRoute,
    intl,
    route: { routeTitle, routePath, layoutId: currentLayoutId },
    error,
    actions: {
      errorActions: { setError },
      localeActions: { setIntl },
      routeActions: { setHistory, changeLayoutRoute, updateRoute },
      notificationActions: { setupNotification },
      scrollbarActions: { scrollToTop },
      companyActions: { setCompanyDomain }
    },
    companyDomain
  } = props;

  const router = { match, location, history };
  const routes = createRoutes();
  const flattenedRoutes = flattenRoutes(routes);
  const classes = MainContainerStyle();

  useEffect(() => {
    console.log('MainContainer useEffect', location.pathname, routePath);
    setIntl(intl);
    setHistory(history);
    updateRouteLayout(location);
    history.listen(location => {
      updateRouteLayout(location);
    });
    const hostname = window.location.hostname;
    if (hostname && companyDomain !== hostname) {
      setCompanyDomain(hostname);
    }
  }, []);

  const setNotificationRef = ref => {
    setupNotification(ref);
  };

  const updateRouteLayout = location => {
    const route = find(flattenedRoutes, route =>
      matchPath(location.pathname, { path: route.path, exact: true })
    );

    if (route) {
      const { layoutId, layout } = route;
      const isDiffLayout = currentLayoutId !== layoutId;
      layout && isDiffLayout && changeLayoutRoute(layoutId, layout);
    }

    if (location.pathname !== routePath) {
      const title = route && route.title;
      updateRoute(title, location.pathname);

      // scroll to top
      scrollToTop && scrollToTop(MAIN_LAYOUT);

      // clear error boundary to render normal page after redirect from crashed page
      error.errorInfo && setError(undefined, undefined);
    }
  };

  return (
    <RouterContext.Provider value={router}>
      <ActionContext.Provider value={actions}>
        <SessionContext.Provider value={session}>
          <LocaleContext.Provider value={locale}>
            <LayoutContext.Provider value={layout}>
              {/* <React.StrictMode> */}
              <AppTitle intl={intl} routeTitle={routeTitle} />
              <ErrorBoundary error={error} setError={setError}>
                <div className={classes.root}>
                  {/* route views */}
                  <LayoutRoute routes={routes} />
                  {
                    /*  <ParentContainerRoute routes={routes} /> */
                  }
                  {
                    /* </LayoutRoute> */
                  }

                  {/* container of system notifications */}
                  <NotificationSystem
                    ref={setNotificationRef}
                    style={NotificationStyle}
                  />
                </div>
              </ErrorBoundary>
              {/* </React.StrictMode> */}
            </LayoutContext.Provider>
          </LocaleContext.Provider>
        </SessionContext.Provider>
      </ActionContext.Provider>
    </RouterContext.Provider>
  );
};

function mapStateToProps (state) {
  return {
    error: state.error,
    layout: state.layout,
    session: state.session,
    route: state.route,
    LayoutRoute: getLayoutRoute(state),
    locale: state.locale,
    companyDomain: getCompanyDomain(state)
  };
}

function mapDispatchToProps (dispatch) {
  return {
    actions: {
      errorActions: bindActionCreators(ErrorActions, dispatch),
      layoutActions: bindActionCreators(LayoutActions, dispatch),
      sessionActions: bindActionCreators(SessionActions, dispatch),
      localeActions: bindActionCreators(LocaleActions, dispatch),
      routeActions: bindActionCreators(RouteActions, dispatch),
      notificationActions: bindActionCreators(NotificationActions, dispatch),
      scrollbarActions: bindActionCreators(ScrollbarActions, dispatch),
      accountActions: bindActionCreators(AccountActions, dispatch),
      dataActions: bindActionCreators(DataActions, dispatch),
      messageActions: bindActionCreators(MessageActions, dispatch),
      dashboardActions: bindActionCreators(DashboardActions, dispatch),
      disclosureActions: bindActionCreators(DisclosureActions, dispatch),
      companyActions: bindActionCreators(CompanyActions, dispatch),
      uploadActions: bindActionCreators(UploadActions, dispatch)
    }
  };
}

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(MainContainer)
  )
);
